/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable max-len */
// @flow

import React, { Component } from 'react';
import * as DOMPurify from 'dompurify';

import EmptyState from 'components/competitionsInternationales/CompetitionsinternationalesSingleMatchEmptyState';
import CompetitionsInternationalesSingleMatchHighlights from 'components/competitionsInternationales/CompetitionsinternationalesSingleMatchHighlights';
import CompetitionsInternationalesSingleMatchStats from 'components/competitionsInternationales/CompetitionsinternationalesSingleMatchStats';
import PrevAndNextMatchesLinks from 'components/competitionsInternationales/PrevAndNextMatchesLinks';
import ContentBloc from 'components/newsletter/blocs/ContentBloc';
import SingleMatchCard from 'components/competitionsInternationales/SingleMatchCard';
import { STATUS_SUCCESS } from 'constants/statusConstants';
import { withHelmet } from 'infrastructure/seo/Helmet';
import type { RencontreType } from 'types/Rencontre';
import type { Status } from 'types/Status';
import { formatFullDateString } from 'utils/dateUtils';

import './CompetitionsInternationalesSingleMatch.css';
import CompetitionsInternationalesSingleMatchComposition from './CompetitionsinternationalesSingleMatchComposition';

export type StateProps = {
  competition: {
    id: string,
    name: string,
    slug: string
  },
  rencontre: RencontreType,
  status: Status
};

type Props = StateProps;

type State = {
  activeComponent: string
};
class CompetitionsInternationalesSingleMatchOver extends Component<Props, State> {
  state: State = {
    activeComponent: ''
  };

  render() {
    const {
      rencontre,
      rencontre: {
        content_match_over,
        news_debrief,
        meta: { equipeNom }
      }
    } = this.props;
    const { activeComponent } = this.state;

    const firstTeam = !!rencontre.meta.reception ? 'France' : rencontre.meta.adversaire;
    const secondTeam = !rencontre.meta.reception ? 'France' : rencontre.meta.adversaire;
    const pageTitle = `${firstTeam} vs ${secondTeam} <br /> ${formatFullDateString(
      new Date(rencontre.meta.date_rencontre)
    )}`;

    return (
      <>
        <h2 className="page-title" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(pageTitle) }} />
        <SingleMatchCard rencontre={{ ...rencontre, ...rencontre.meta }} simple={true} equipeNom={equipeNom} />
        <nav className="single-match__nav">
          <ul>
            <li
              className={activeComponent === '' ? 'active' : ''}
              onClick={() => this.setState({ activeComponent: '' })}
            >
              <span>Live Score</span>
            </li>
            <li
              className={activeComponent === 'composition' ? 'active' : ''}
              onClick={() => this.setState({ activeComponent: 'composition' })}
            >
              <span>Composition</span>
            </li>
            <li
              className={activeComponent === 'statistiques' ? 'active' : ''}
              onClick={() => this.setState({ activeComponent: 'statistiques' })}
            >
              <span>Statistiques</span>
            </li>
            <li
              className={activeComponent === 'debriefing' ? 'active' : ''}
              onClick={() => this.setState({ activeComponent: 'debriefing' })}
            >
              <span>Résumé</span>
            </li>
          </ul>
        </nav>

        {activeComponent === '' && <CompetitionsInternationalesSingleMatchHighlights rencontre={rencontre} />}

        {activeComponent === 'composition' && (
          <CompetitionsInternationalesSingleMatchComposition rencontre={rencontre} />
        )}

        {activeComponent === 'statistiques' && <CompetitionsInternationalesSingleMatchStats rencontre={rencontre} />}

        {activeComponent === 'debriefing' && (
          <article className="container article">
            {!!news_debrief &&
            !!news_debrief.content &&
            !!news_debrief.content.data &&
            !!news_debrief.content.data.length ? (
              news_debrief.content.data.map((bloc, index) => <ContentBloc key={index} {...bloc} />)
            ) : (
              <EmptyState
                titleFirstPart="Résumé"
                titleSecondPart="de match"
                description="Le résumé de match sera disponible très prochainement."
                backgroundImage="/img/empty-state-avant-match.png"
              />
            )}
          </article>
        )}

        <PrevAndNextMatchesLinks prevAndNextMatchesLinks={rencontre.prev_and_next_match_links} />

        {!!content_match_over &&
          !!content_match_over.data &&
          !!content_match_over.data.length &&
          content_match_over.data.map((bloc, index) => <ContentBloc key={index} {...bloc} />)}
      </>
    );
  }
}

export default withHelmet(CompetitionsInternationalesSingleMatchOver)((Helmet, pageProps: Props) => {
  const { competition, rencontre, status } = pageProps;

  if (status !== STATUS_SUCCESS || !competition || !rencontre) {
    null;
  }

  const firstTeam = !!rencontre.meta.reception ? 'France' : rencontre.meta.adversaire;
  const secondTeam = !rencontre.meta.reception ? 'France' : rencontre.meta.adversaire;

  const meta_title = `${firstTeam} vs ${secondTeam} : Détails & Analyse - ${formatFullDateString(
    new Date(rencontre.meta.date_rencontre)
  )} - ${competition.name} FFR`;

  return (
    <Helmet htmlAttributes={{ lang: 'fr' }}>
      {meta_title && <title>{meta_title}</title>}
      {meta_title && <meta property={'og:title'} content={meta_title} />}
    </Helmet>
  );
});
